import React, { Component } from "react";
import PropTypes from "prop-types";
import { Dropdown, Menu, Spin } from "antd";
import { getRenewalPrices } from "../../../services/api-patents";
import { sortBy } from "lodash";
import { toDateString } from "../../../helpers/converters";

const vendorInfo = {
  "patentrenewal.com": {
    logoUrl: "https://public-assets.unifiedpatents.com/patent_renewal_vendors/pr.png",
    title: "Patentrenewal.com ApS"
  }
};

class Renew extends Component {
  static propTypes = {
    ucid: PropTypes.string.isRequired
  };

  state = {
    loading: false,
    prices: []
  };

  componentDidMount() {
    this._isMounted = true;
    this._getPrices();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { prices, loading } = this.state;
    const menu = (
      <Menu>
        <Menu.Item key="header" disabled={true}>
          <div style={{ display: "flex" }}>
            <div style={{ minWidth: 50 }}>Vendor</div>
            <div style={{ minWidth: 80 }}>Price</div>
            <div style={{ minWidth: 50 }}>Year</div>
            <div style={{ minWidth: 80 }}>Due Date</div>
          </div>
        </Menu.Item>
        {prices.map(p => (
          <Menu.Item key={p.vendor}>
            <a target="_new" rel="nofollow" href={`https://${p.vendor_link}`}>
              <div style={{ display: "flex" }}>
                <div style={{ minWidth: 50 }}>{vendorInfo[p.vendor] ? <img width={16} height={16} src={vendorInfo[p.vendor].logoUrl} alt={vendorInfo[p.vendor].title} /> : null}</div>
                <div style={{ minWidth: 80 }}>{`$${p.price.toLocaleString()}`}</div>
                <div style={{ minWidth: 50 }}>{p.annuity_year}</div>
                <div style={{ minWidth: 80 }}>{toDateString(p.last_acceptable_payment_date)}</div>
              </div>
            </a>
          </Menu.Item>
        ))}
      </Menu>
    );
    return (
      <Dropdown.Button type="primary" disabled={prices.length === 0} onClick={this._onButtonClick} overlay={menu}>
        <div>RENEW {loading ? <Spin /> : prices.length > 0 ? `($${prices[0].price.toLocaleString()})` : null}</div>
      </Dropdown.Button>
    );
  }

  _getPrices = () => {
    if (this._isMounted) this.setState({ loading: true });
    getRenewalPrices(this.props.ucid)
      .then(prices => {
        if (this._isMounted) this.setState({ prices: sortBy(prices, "price"), loading: false });
      })
      .catch(() => {
        if (this._isMounted) this.setState({ prices: [], loading: false });
      });
  };

  _onButtonClick = () => {
    // go to link of lowest price vendor
    window.open(`https://${this.state.prices[0].vendor_link}`, "_new");
  };
}

export default Renew;
